import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/scss/image-gallery.scss';
import './styles.scss';

export default function ImageGalleryComponent({ ...props }) {
  return <ImageGallery {...props} />;
}
